export default "__VITE_ASSET__DQXJX3TC__"